import React, {Component} from "react";
import {Box, Grid, Typography} from '@deere/fuel-react';
import {Dropdown, List} from "@deere/ux.uxframe-react";

import {MAX_RESULT_PER_PAGE} from "../shared/Constants";
import {Loading} from "../shared/Loading";
import {NoData} from "../shared/NoData";
import PaginationData from "../shared/PaginationData";

class FeedbackList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            total: 0,
            perPage: MAX_RESULT_PER_PAGE,
            selectedOption: "Closest",
            listToShow: [],
            isLoading: true
        };
    }

    updateComponent(){
        this.setState({
            total: this.props.list.length,
            listToShow: this.props.list.sort(function (a, b) {
                const dateA = new Date(a.dueDate).getTime();
                const dateB = new Date(b.dueDate).getTime();
                return dateA < dateB ? -1 : 1;
            }),
            page: 1,
            perPage: MAX_RESULT_PER_PAGE,
            selectedOption: "Closest",
            isLoading: false
        });
    }

    componentDidMount() {
        if (!!this.props?.list) {
            this.updateComponent()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list !== this.props.list) {
            this.updateComponent()
        }
    }

    setSortingOption(sortMethod) {
        this.setState({selectedOption: sortMethod}, () => {
            this.sortData()
        });
    }

    sortData = () => {
        if (this.state.selectedOption === "Furthest") {
            const sortedList = this.state.listToShow.sort(function (a, b) {
                const dateA = new Date(a.props.feedback.dueDate).getTime();
                const dateB = new Date(b.props.feedback.dueDate).getTime();
                return dateA < dateB ? 1 : -1;
            })
            this.setState({
                listToShow: sortedList
            });
        } else if (this.state.selectedOption === "Closest") {
            const sortedList = this.state.listToShow.sort(function (a, b) {
                const dateA = new Date(a.props.feedback.dueDate).getTime();
                const dateB = new Date(b.props.feedback.dueDate).getTime();
                return dateA < dateB ? -1 : 1;
            })
            this.setState({
                listToShow: sortedList
            });
        }

        this.setState({page: 1}); // Resetting page to 1
    };

    getEventHandler = data => {
        this.setState({page: data.page});
    }

    render() {
        const pageData = {
            page: this.state.page,
            total: this.state.total,
            perPage: this.state.perPage
        }
        const eventHandler = data => {
            this.getEventHandler(data)
        };
        const {total, page, perPage, isLoading} = this.state;
        const noDataMessage = {
            textLine1: "No results found. Please try a new search term or expanding your filter criteria."
        }

        return (
            <>
                {total > 0 && (
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <Box display="flex" p={2} justifyContent="flex-start">
                                <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                                    {total} Results
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box display="flex" p={2} justifyContent="flex-end">
                                <Typography size="md" fontWeight="bold" component="p"
                                            style={{paddingRight: 10, paddingTop: 2}}>
                                    Sort By
                                </Typography>
                                <Typography size="md" fontWeight="bold" component="p"
                                            style={{paddingRight: 10, paddingTop: 2}}>
                                    Due Date
                                </Typography>
                                <Dropdown>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic-3" style={{padding: 0}}>
                                        {this.state.selectedOption}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() => {
                                                this.setSortingOption("Closest");
                                            }}
                                        >
                                            Closest
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => {
                                                this.setSortingOption("Furthest");
                                            }}
                                        >
                                            Furthest
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Box>
                        </Grid>
                    </Grid>
                )}
                {isLoading && (
                    <Loading/>
                )}
                {!isLoading && this.state.listToShow.length !== 0 && (
                    <List className="list-group">
                        {this.state.listToShow.slice(
                            (page - 1) * perPage,
                            (page - 1) * perPage + perPage
                        )}
                    </List>
                )}
                {!isLoading && this.state.listToShow.length === 0 && (
                    <NoData noDataMessage={noDataMessage}/>
                )}

                {total > MAX_RESULT_PER_PAGE && (
                    <PaginationData pageData={pageData} onChange={eventHandler}/>
                )}
            </>
        );
    }
}

export default FeedbackList;
